'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _clsx = require('clsx');

var _clsx2 = _interopRequireDefault(_clsx);

var _Divider = require('./Divider.style');

var _Divider2 = _interopRequireDefault(_Divider);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Divider = (_dec = (0, _reactJss2["default"])(_Divider2["default"]), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(Divider, _PureComponent);

  function Divider() {
    (0, _classCallCheck3["default"])(this, Divider);
    return (0, _possibleConstructorReturn3["default"])(this, (Divider.__proto__ || (0, _getPrototypeOf2["default"])(Divider)).apply(this, arguments));
  }

  (0, _createClass3["default"])(Divider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className;
      return _react2["default"].createElement('hr', {
        className: (0, _clsx2["default"])(className, classes.divider)
      });
    }
  }]);
  return Divider;
}(_react.PureComponent)) || _class);
Divider.propTypes = {
  classes: _propTypes2["default"].object,

  /** additional external class name */
  className: _propTypes2["default"].string
};
exports["default"] = Divider;